import React from 'react';
import './style.scss';

export enum HistoryStatus {
  reception = 1,
  decide = 2,
  cancel = 3,
  itReception = 4,
}

type HistoryStatusMap = {
  [P in HistoryStatus]: { className: string };
};
const HistoryStatusMap: HistoryStatusMap = {
  1: { className: 'statusReception' },
  2: { className: 'statusDecide' },
  3: { className: 'statusCancel' },
  4: { className: 'statusItReception'},
};

type HistoryStatusIconProps = {
  status: HistoryStatus;
};

export const HistoryStatusIcon = ({ status }: HistoryStatusIconProps) => {
  return <span className={`historyStatus ${HistoryStatusMap[status].className}`} />;
};
